import * as React from 'react'

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" style={{ margin: 2 }}>
    <circle cx="4" cy="4" r="4" fill="#001335" />
  </svg>
)
